import React from 'react';
import { CheckIcon, GlobeIcon, TrophyIcon } from 'lucide-react';
import { Section } from '../Section';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { PRICE } from '../../data/content';
const includes = ['One-time payment', 'No subscriptions', 'Instant access', 'Lifetime access'];
export function Offer() {
  return <Section id="offer" tone="panel" data-id="element-196" data-mp="3a4dz8f2q4s96">
      <div className="mx-auto w-full max-w-2xl" data-id="element-197" data-mp="3a3ck9zil7lm6">
        <p className="flex items-center justify-center gap-2 text-center text-[11px] font-bold uppercase tracking-[0.2em] text-ember sm:text-xs" data-id="element-198" data-mp="3f3qi6oqh5f6h">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-199" data-mp="3jxcwsmg77t4x" />
          Special launch offer
        </p>
        <h2 className="mt-2 text-center font-display text-[26px] font-bold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-200" data-mp="3nyof06wqtc33">
          Everything you’ll get today
        </h2>

        <div className="mt-6 rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-7" data-id="element-201" data-mp="1q5dnqymd1qi">
          <dl className="space-y-3" data-id="element-202" data-mp="1km9nr8mu4fw7">
            <div className="flex items-baseline justify-between gap-3 border-b border-white/10 pb-3" data-id="element-203" data-mp="1kj3xhq2gz7yw">
              <dt className="text-[15px] font-bold uppercase leading-tight text-white" data-id="element-204" data-mp="1bks81rdcag81">
                6 Master Manuals
              </dt>
              <dd className="shrink-0 text-[15px] font-bold text-white/45 line-through" data-id="element-205" data-mp="16mqq59rngmy5">
                {PRICE.manualsValue}
              </dd>
            </div>
            <div className="flex items-baseline justify-between gap-3 border-b border-white/10 pb-3" data-id="element-206" data-mp="1zacp24pxn3eo">
              <dt className="text-[15px] font-bold uppercase leading-tight text-white" data-id="element-207" data-mp="1uje9568uw7by">
                5 Exclusive Bonuses
              </dt>
              <dd className="shrink-0 text-[15px] font-bold text-white/45 line-through" data-id="element-208" data-mp="1pjrxh18oez59">
                {PRICE.bonusValue}
              </dd>
            </div>
            <div className="flex items-baseline justify-between gap-3" data-id="element-209" data-mp="2i9iaf6yknuzs">
              <dt className="text-[15px] font-extrabold uppercase leading-tight text-teal-bright" data-id="element-210" data-mp="2i75o6hls6ygx">
                Total value
              </dt>
              <dd className="shrink-0 font-display text-2xl font-bold text-teal-bright" data-id="element-211" data-mp="364ts4so4usxo">
                {PRICE.totalValue} USD
              </dd>
            </div>
          </dl>

          <div className="mt-6 border-t border-white/10 pt-6 text-center" data-id="element-212" data-mp="2weio764g8jqs">
            <p className="text-[13px] font-bold uppercase tracking-wide text-white/55" data-id="element-213" data-mp="2wce8zs13nyb7">
              But you won’t pay {PRICE.totalValue}…
            </p>
            <p className="mt-3 text-[13px] font-semibold uppercase leading-tight text-white/70" data-id="element-214" data-mp="2nevkgdo8z1uk">
              Get the complete Master Welding System™ today for only
            </p>
            <div className="mt-2 flex items-end justify-center gap-3" data-id="element-215" data-mp="2df4pybzosmuh">
              <span className="font-display text-2xl font-bold text-white/40 line-through" data-id="element-216" data-mp="7my7nnhwkijs">
                {PRICE.totalValue}
              </span>
              <span className="font-display text-[64px] font-extrabold leading-none text-teal-bright sm:text-7xl" data-id="element-217" data-mp="bn8gr90zrp2v">
                {PRICE.today}
              </span>
              <span className="pb-2 text-base font-bold uppercase text-white/70" data-id="element-218" data-mp="1s5ij5abx0ruc">
                USD
              </span>
            </div>

            <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-2" data-id="element-219" data-mp="25xydlmqr3hjn">
              {includes.map(item => <li key={item} className="flex items-center gap-2 rounded-lg border border-white/10 bg-ink-900 px-3 py-2 text-left" data-id="element-220" data-mp="213kepacvqsa8">
                  <CheckIcon className="h-4 w-4 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-221" data-mp="2av6z9xb3y3pn" />
                  <span className="text-[12px] font-semibold leading-tight text-white/85" data-id="element-222" data-mp="2jvn2d5nxv8tz">
                    {item}
                  </span>
                </li>)}
            </ul>

            <p className="mx-auto mt-4 flex max-w-md items-start gap-2 rounded-lg border border-teal/25 bg-teal/[0.06] px-3 py-2.5 text-left" data-id="element-223" data-mp="pindsn1kz4ak">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-224" data-mp="rw9074xyqrw3" />
              <span className="text-[13px] leading-snug text-white/75" data-id="element-225" data-mp="10xqfil3jqpjq">
                <strong className="font-bold text-white" data-id="element-226" data-mp="10vdxy91pah77">
                  Automatic currency conversion.
                </strong>{' '}
                Your currency conversion is handled automatically, so you pay the
                equivalent amount in your local currency wherever you are in the
                world.
              </span>
            </p>

            <p className="mt-4 text-[14px] italic leading-relaxed text-white/55" data-id="element-227" data-mp="i5xw9iea4ip7">
              Less than the cost of a small box of welding electrodes — for a
              practical reference system you can keep using for years.
            </p>

            <div className="mt-6" data-id="element-228" data-mp="3llv7zvs39ypn">
              <ScarcityBar data-id="element-229" data-mp="3qm0vczrbsz1x" />
            </div>

            <div className="mt-6" data-id="element-230" data-mp="3qkpqewm59l98">
              <CtaButton label="Get the Master Welding System™" data-id="element-231" data-mp="3j301752f0hr8" />
              <Countdown className="mt-6" data-id="element-232" data-mp="3j17005akmpqm" />
            </div>
          </div>
        </div>
      </div>
    </Section>;
}